// @flow
import React from 'react'
import './styles.scss'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/grid.css'
import { CopyrightNotice } from '@ta-interaktiv/react-copyright-notice'
import { UserFeedback } from '@ta-interaktiv/react-user-feedback'
import { FeedbackMessage } from '@ta-interaktiv/react-feedback-message'
import { ShareButtons } from '@ta-interaktiv/react-share-buttons'

type Props = {
  articleId: string
}

export function Footer({ articleId }: Props) {
  return (
    <footer className='ta footer' style={{ height: '100%' }}>
      <div className='ui container'>
        <div className='ui grid'>
          <div className='two column centered stackable row'>
            <div className='column'>
              <UserFeedback
                theme='simple'
                starIcon='star'
                articleId={articleId}
                starColor='blue'
                starAmount='5'
                title='Wie bewerten Sie diesen Beitrag?'
                questions={[
                  'Wie gefällt Ihnen das Format der Comic-Reportage?',
                  'Wie gut ist die Bedienbarkeit?'
                ]}
              />
            </div>
          </div>
          <div className='two column stackable row'>
            <div className='column'>
              <table className='ui small very basic definition infographic unstackable compact table'>
                <tbody>
                  <tr>
                    <td>Zeichnungen & Text</td>
                    <td>Felix Schaad</td>
                  </tr>
                  <tr>
                    <td>Digitale Umsetzung</td>
                    <td>Mathias Lutz</td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div className='column'>
              <FeedbackMessage question='Haben Sie Feedback für uns?' />
            </div>
          </div>

          <div className='one column stackable row copyright'>
            <div className='column'>{/* <CopyrightNotice /> */}</div>
          </div>
        </div>
      </div>
    </footer>
  )
}
